export default __webpack_public_path__ + "static/media/team-blank.e255b465.jpg";